<!-- MODAL HEADER -->
<div class="modal-header">
  <h3 class="modal-title"><strong>Attribute Mapping</strong></h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- MODAL BODY -->
<form class="form-horizontal" [hidden]="minimise" novalidate>
<div class="modal-body">

  @if (isLockedWarningMsgs) {
<div class="warning-msg-class">
    <strong>{{ isLockedWarningMsgs }}</strong>
  </div>
}

  <div class="divShadow1">
    <div style="margin-left: 30px; margin-right: 30px; margin-bottom: 30px">

      <!-- ROW 1: Attributes + single-select dropdowns -->
      <div class="row">

        <!-- Attributes -->
        <div class="col-md-2">
          <label>Attributes</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="attributeDataView"
  [selectType]="'single'" [title]="'Attribute'" [hideTitleOnInput]="true" [inputAriaLabel]="'Attribute'"
  [(ngModel)]="selectedAttributesItem"
  name="selectedAttributes"
  (onSelect)="onChangeAttributeFromDropdown($event)">
  @for (item of attributeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Attribute')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>

        <!-- Country (show when COUNTRY_CODE) -->
        @if (selectedAttributes?.CODE_KEY === 'COUNTRY_CODE') {
<div class="col-md-2">
          <label>Country</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="countryCodeDataView"
  [selectType]="'single'" [title]="'Country'" [hideTitleOnInput]="true" [inputAriaLabel]="'Country'"
  [showSearchbox]="true"
  [(ngModel)]="selectedCountryCodeItem"
  name="selectedCountryCode"
  (onSelect)="onSelectedCountryCodeSelect($event)">
  @for (item of countryCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Country')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- SIC Code -->
        @if (selectedAttributes?.CODE_DESCRIPTION === 'SIC CODE') {
<div class="col-md-2">
          <label>SIC Code</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="sicCodeDataView"
  [selectType]="'single'" [title]="'SIC Code'" [hideTitleOnInput]="true" [inputAriaLabel]="'SIC Code'"
  [showSearchbox]="true"
  [(ngModel)]="selectedSICCOdeItem"
  name="selectedSICCode"
  (onSelect)="onSelectedSICCOdeSelect($event)">
  @for (item of sicCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'SIC Code')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- Basket -->
        @if (selectedAttributes?.CODE_DESCRIPTION === 'BASKET') {
<div class="col-md-2">
          <label>Basket</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseBasketDataAttributeInfoView"
  [selectType]="'single'" [title]="'Basket'" [hideTitleOnInput]="true" [inputAriaLabel]="'Basket'"
  [(ngModel)]="selectedBasketInfoByAttrItem"
  name="selectedBasketInfoByAttr"
  (onSelect)="onSelectedBasketInfoByAttrSelect($event)">
  @for (item of baseBasketDataAttributeInfoView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Basket')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- FDII -->
        @if (selectedAttributes?.CODE_DESCRIPTION === 'FDII') {
<div class="col-md-2">
          <label>FDII</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseFdiiDataAttributeInfoView"
  [selectType]="'single'" [title]="'FDII'" [hideTitleOnInput]="true" [inputAriaLabel]="'FDII'"
  [(ngModel)]="selectedBaseFdiiInfoByAttrItem"
  name="selectedBaseFdiiInfoByAttr"
  (onSelect)="onSelectedBaseFdiiInfoByAttrSelect($event)">
  @for (item of baseFdiiDataAttributeInfoView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'FDII')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- BEAT -->
        @if (selectedAttributes?.CODE_DESCRIPTION === 'BEAT') {
<div class="col-md-2">
          <label>BEAT</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="yesNoDataView"
  [selectType]="'single'" [title]="'BEAT'" [hideTitleOnInput]="true" [inputAriaLabel]="'BEAT'"
  [(ngModel)]="selectedBeatCodeItem"
  name="selectedBeatCode"
  (onSelect)="onSelectedBeatCodeSelect($event)">
  @for (item of yesNoDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'BEAT')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- BEAT Type -->
        @if (selectedAttributes?.CODE_DESCRIPTION === 'BEAT') {
<div class="col-md-2">
          <label>BEAT Type</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="beatTypeDataView"
  [selectType]="'single'" [title]="'BEAT Type'" [hideTitleOnInput]="true" [inputAriaLabel]="'BEAT Type'"
  [disabled]="selectedBeatCode?.CODE_DESCRIPTION === 'No'"
  [(ngModel)]="selectedBeatTypeCodeItem"
  name="selectedBeatTypeCode"
  (onSelect)="onSelectedBeatTypeCodeSelect($event)">
  @for (item of beatTypeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'BEAT Type')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- BEAT Withhold -->
        @if (selectedAttributes?.CODE_DESCRIPTION === 'BEAT') {
<div class="col-md-2">
          <label>Subject to BEAT Withhold (%)</label>
          <input type="text" class="form-control" style="width: 75px"
                 [(ngModel)]="selectedBeatWithhold" name="selectedBeatWithhold"
                 [ngClass]="{'disabled': selectedBeatCode?.CODE_DESCRIPTION === 'No'}"
                 (ngModelChange)="changeSelectedBeatWithHold()">
        </div>
}
      </div>

      <!-- ROW 2: Method & Base fields -->
      @if (selectedAttributes?.CODE_DESCRIPTION === 'METHOD & BASE') {
<div class="row">

        <!-- Method -->
        <div class="col-md-2">
          <label>Method</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="methodCodeDataView"
  [selectType]="'single'" [title]="'Method'" [hideTitleOnInput]="true" [inputAriaLabel]="'Method'"
  [(ngModel)]="selectedMethodCodeItem"
  name="selectedMethodCode"
  (onSelect)="onOnMethodChangeFromDropdown($event)">
  @for (item of methodCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Method')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>

        @if (intExpHideBaseFields == 'false') {

          <!-- Multi-select mode -->
          @if (displaySingleSelectBase != 'true') {


            @if (baseFDIIData.length > 0) {
<div class="col-md-2">
              <label>Base FDII</label>
              <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                             [list]="dropdownLists['baseFDII']" [optionName]="'CODE_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                             [title]="'Select'" [inputAriaLabel]="'Base FDII'" [hideTitleOnInput]="true"
                             [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                             (onFilterResult)="onDropdownFilterResult('baseFDII', $event)"
                             [(ngModel)]="selectedBaseFdiiCodes" name="baseFdiiMulti">
              </ap-dropdown>
            </div>
}

            @if (baseBasketData.length > 0) {
<div class="col-md-2">
              <label>Base Basket</label>
              <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                             [list]="dropdownLists['baseBasket']" [optionName]="'CODE_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                             [title]="'Select'" [inputAriaLabel]="'Base Basket'" [hideTitleOnInput]="true"
                             [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                             (onFilterResult)="onDropdownFilterResult('baseBasket', $event)"
                             [(ngModel)]="selectedBaseBasketCode" name="baseBasketMulti">
              </ap-dropdown>
            </div>
}

            @if (baseTypeData.length > 0 && gIncomeMethodFlag != 'true') {
<div class="col-md-2">
              <label>Base Type</label>
              <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                             [list]="dropdownLists['baseType']" [optionName]="'CODE_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                             [title]="'Select'" [inputAriaLabel]="'Base Type'" [hideTitleOnInput]="true"
                             [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                             (onFilterResult)="onDropdownFilterResult('baseType', $event)"
                             [(ngModel)]="selectedBaseTypeCode" name="baseTypeMulti"
                             [disabled]="selectedMethodCode?.CODE_KEY === undefined">
              </ap-dropdown>
            </div>
}

            @if (baseTypeData.length > 0 && gIncomeMethodFlag == 'true') {
<div class="col-md-2">
              <label>Base Type</label>
              <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                             [list]="dropdownLists['baseType']" [optionName]="'CODE_UPDATED_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                             [title]="'Select'" [inputAriaLabel]="'Base Type'" [hideTitleOnInput]="true"
                             [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                             (onFilterResult)="onDropdownFilterResult('baseType', $event)"
                             [(ngModel)]="selectedBaseTypeCode" name="baseTypeMultiGI"
                             [disabled]="selectedMethodCode?.CODE_KEY === undefined">
              </ap-dropdown>
            </div>
}

            <div class="col-md-2">
              <label>Base Level</label>
              <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseLevelDataView"
  [selectType]="'single'" [title]="'Base Level'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base Level'"
  [disabled]="disableBaseLevel"
  [(ngModel)]="selectedBaseLevelCodeItem"
  name="selectedBaseLevelCode"
  (onSelect)="onSelectedBaseLevelCodeSelect($event)">
  @for (item of baseLevelDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base Level')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
            </div>

            <div class="col-md-2">
              <label>Base Entity Level</label>
              <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseEntityDataView"
  [selectType]="'single'" [title]="'Base Entity Level'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base Entity Level'"
  [disabled]="disableBaseLevel"
  [(ngModel)]="selectedBaseEntityLevelCodeItem"
  name="selectedBaseEntityLevelCode"
  (onSelect)="onSelectedBaseEntityLevelCodeSelect($event)">
  @for (item of baseEntityDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base Entity Level')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
            </div>
          
}

          <!-- Single-select mode (Allocate) -->
          @if (displaySingleSelectBase == 'true') {

            @if (baseFDIIData.length > 0) {
<div class="col-md-2">
              <label>Base FDII</label>
              <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseFDIIDataView"
  [selectType]="'single'" [title]="'Base FDII'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base FDII'"
  [(ngModel)]="selectedBaseFdiiCodesItem"
  name="baseFdiiSingle"
  (onSelect)="onSelectedBaseFdiiCodesSelect($event)">
  @for (item of baseFDIIDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base FDII')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
            </div>
}

            @if (baseBasketData.length > 0) {
<div class="col-md-2">
              <label>Base Basket</label>
              <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="basketCodeAllocateDataView"
  [selectType]="'single'" [title]="'Base Basket'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base Basket'"
  [(ngModel)]="selectedBaseBasketCodeItem"
  name="baseBasketSingle"
  (onSelect)="onSelectedBaseBasketCodeSelect($event)">
  @for (item of basketCodeAllocateDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base Basket')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
            </div>
}
          
}
        
}
      </div>
}

      <!-- GRID TABLE -->
      <div class="row" style="margin-top: 15px;">
        <div class="col-md-12">
          <div class="table-scroll" style="padding-top: 0 !important;">
            <table class="main-table">
              <thead>
                <tr>
                  <th class="sticky-col"></th>
                  <th class="sticky-col" style="text-align: center;">Warning</th>
                  <th class="sticky-col" style="text-align: center;">LEID</th>
                  <th class="sticky-col" style="text-align: center;">Tax Code</th>
                  <th class="sticky-col" style="text-align: center;">Reporting Period</th>
                  <th class="sticky-col" style="text-align: center;">Me Code</th>
                  <th class="sticky-col" style="text-align: center;">Gross Inc/Exp</th>
                  <th class="sticky-col" style="text-align: center;">Transaction Category</th>
                </tr>
              </thead>
              <tbody>
                @for (t of gridDataMultipleSelect; track $index) {
<tr>
                  <td><i class="fa fa-times" style="cursor: pointer;" (click)="removeAttribBatchUpdateRow(t)"></i></td>
                  <td [ngClass]="{'warning-class': t?.data?.STATUS_FLAG === 'Locked', 'default-color': t?.data?.STATUS_FLAG === 'Unlocked'}"
                      style="width:60px;">
                    @if (t?.data?.STATUS_FLAG === 'Locked') {
<span>Already Locked</span>
}
                  </td>
                  <td>{{ t?.data?.LEID }}</td>
                  <td>{{ t?.data?.CDR_NO }}</td>
                  <td>{{ t?.data?.REPORTING_PERIOD }}</td>
                  <td>{{ t?.data?.ME_CODE }}</td>
                  <td>{{ t?.data?.GIE_SHORT_DESC }}</td>
                  <td>{{ t?.data?.TRANS_CATG_NAME }}</td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</form>

<!-- MODAL FOOTER -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" (click)="save()"
          [disabled]="isLockedWarningExists || isSaveClicked">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-danger-outline btn-sm" type="button" (click)="resetBatch()">Reset</button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
